import { render, staticRenderFns } from "./PatientModifier.vue?vue&type=template&id=16770c6a&"
import script from "./PatientModifier.vue?vue&type=script&lang=js&"
export * from "./PatientModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports